import { render, staticRenderFns } from "./ServiceFaq.vue?vue&type=template&id=a49fb222"
import script from "./ServiceFaq.vue?vue&type=script&lang=js"
export * from "./ServiceFaq.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports